import { render, staticRenderFns } from "./BookingVoucher.vue?vue&type=template&id=563dc0de&"
import script from "./BookingVoucher.vue?vue&type=script&lang=js&"
export * from "./BookingVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports